import i18n from '@/localization';
import { LOCALIZATION_OPTIONS } from './constants';

export const setLocale = (locale: string) => {
  i18n.changeLanguage(locale);
};

export const localeToOption = (locale: string) => LOCALIZATION_OPTIONS.find((option) => locale.includes(option.id.toString()));
